import React from 'react';
import { getStrategyConfig } from '../config/strategyConfig';

/**
 * ProsCons Component
 * Displays strategy-specific pros and cons
 */
function ProsCons({ strategyType, strategyData }) {
  const config = getStrategyConfig(strategyType);
  
  const pros = strategyData?.pros || [];
  const cons = strategyData?.cons || [];

  if (pros.length === 0 && cons.length === 0) {
    return null;
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      {/* Pros */}
      {pros.length > 0 && (
        <div className="bg-green-50 rounded-lg border border-green-200 p-3 sm:p-4">
          <h4 className="font-bold text-green-900 mb-2 sm:mb-3 flex items-center gap-2 text-sm">
            <span>✓</span>
            <span className="truncate">Pros for {config.shortName}</span>
          </h4>
          <ul className="space-y-2">
            {pros.map((pro, idx) => (
              <li key={idx} className="text-xs sm:text-sm text-green-800 flex items-start gap-2">
                <span className="text-green-500 mt-0.5 flex-shrink-0">•</span>
                <span className="break-words">{pro}</span>
              </li>
            ))}
          </ul>
        </div>
      )}

      {/* Cons */}
      {cons.length > 0 && (
        <div className="bg-red-50 rounded-lg border border-red-200 p-3 sm:p-4">
          <h4 className="font-bold text-red-900 mb-2 sm:mb-3 flex items-center gap-2 text-sm">
            <span>⚠</span>
            <span>Cons to Consider</span>
          </h4>
          <ul className="space-y-2">
            {cons.map((con, idx) => (
              <li key={idx} className="text-xs sm:text-sm text-red-800 flex items-start gap-2">
                <span className="text-red-500 mt-0.5 flex-shrink-0">•</span>
                <span className="break-words">{con}</span>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}

export default ProsCons;
